import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import React, { useEffect, useState } from 'react';
import InvoiceIcon from '../../../assets/images/icons/invoice-pdf.svg';
import { ApiData } from '../../../data/apiData';

export default function BillingHistory() {
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [billingHistory, setBillingHistory] = useState([]);
    useEffect(() => {
        ApiData.getBilling().then(data => setBillingHistory(data));
    }, []);

    const invoicePDF = () => {
        return (
            <div className="invoiceBtn flex justify-content-center">
                <Button link><Image src={InvoiceIcon} alt="Image" width="25" /></Button> 
            </div>
        );
    };

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport NextPageLink PrevPageLink',
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 120, value: 120 }
            ];

            return (
                <React.Fragment>
                    <div className='paginatorLeft'>
                        <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                            Rows per page {' '}
                        </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return (
                <div className='paginatorRight'>
                    <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                        Pages {options.first} of {options.totalRecords}
                    </span>
                </div>
            );
        }
    };
    
    return (
        <div>
            <DataTable value={billingHistory}
                emptyMessage="No customers found."  
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                paginatorTemplate={paginatorTemplate}
                //paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                //currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                // paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}
                tableStyle={{ minWidth: '50rem' }} resizableColumns>
                <Column field="date" header="Date" filterPlaceholder="Search by name" bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="billingItem" header="Billing Item" headerStyle={{ textAlign: 'left' }} alignHeader={'left'} bodyStyle={{ textAlign: 'left' }}></Column>
                <Column field="charges" header="Charges" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column> 
                <Column field="status" header="Status" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column field="invoice" body={invoicePDF} header="Invoice" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>
        </div>
    )
}
